module.exports = __webpack_public_path__ + "static/media/Defi.362a01b0.jpeg";